import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getUserById, updateUserById } from "../modules/actions";
import { getSuppliers } from "../../Dobavljaci/modules/actions";
import EditUser from "./View";

const mapStateToProps = (state) => ({
  userState: {
    currentUser: state.usersReducer.userToEdit,
    suppliersOptions: state.suppliersReducer.suppliers,
  },
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      getUserById,
      updateUserById,
      getSuppliers,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditUser);
